var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7647 8.82351V2.94116H8.82353C3.95824 2.94116 0 6.8994 0 11.7647V41.1765H0.000196078C0.00343137 44.4206 2.64363 47.0588 5.88853 47.0588H50V8.82351H11.7647ZM2.94118 11.7647C2.94118 8.52116 5.58 5.88234 8.82353 5.88234V35.2941H5.88235C4.81176 35.2941 3.80686 35.5818 2.94118 36.0835V11.7647ZM47.0588 44.1176H5.88843C4.26441 44.1176 2.94284 42.797 2.94118 41.1734C2.94294 39.553 4.26167 38.2353 5.88235 38.2353H11.7647V11.7647H47.0588V44.1176Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3529 38.2353H29.4118V35.2941H32.3529V32.3529H23.5294V35.2941H26.4706V38.2353H20.5882V29.4118H23.5294V26.4706H20.5882V23.5294H23.5294V20.5882H20.5882V17.647H29.4118V23.5294H26.4706V26.4706H35.2941V23.5294H32.3529V17.647H41.1765V29.4118H35.2941V35.2941H38.2353V32.3529H41.1765V38.2353H35.2941V41.1765H44.1176V14.7059H17.6471V41.1765H32.3529V38.2353Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlanIcon);
export default __webpack_public_path__ + "static/media/floor-plan-icon.48d894da4718f8043709949d961a64d9.svg";
export { ForwardRef as ReactComponent };